export default __webpack_public_path__ + "static/media/step_details_book.db326f47.png";